module.exports = __webpack_public_path__ + "img/logo-20-years-white-sm.c3ebaa5f.png";